import Dialog from "../../1. Core/Controls/Dialog/Dialog";
import {Collection, Pack} from "../types";
import TextField from "../../1. Core/Controls/TextField/TextField";
import NumField from "../../1. Core/Controls/TextField/NumField";
import Select from "../../1. Core/Controls/Select/Select";
import {ServerAPI} from "../../1. Core/ServerAPI";
import SelectFighterCtrl from "../../2. Athletes/SelectFighterCtrl";
import {SportType} from "../../10. Battle/types";
import ImageTextField from "../../1. Core/Controls/TextField/ImageTextField";


export default class EditPackDialog extends Dialog {
    private _Pack: Pack;
    private _name_en: TextField;
    private _name_ru: TextField;
    private _name_es: TextField;
    private _name_pt: TextField;
    private _backgroundColorInput: TextField;
    private completion_giftInput: TextField;
    private _rewardFighterCtrl: SelectFighterCtrl;
    private _rewardCoinsInput: NumField;
    private _rewardDiamondsInput: NumField;
    private _rewardCardPackageStatusSelect: Select;
    private _rewardAvatarCategorySelect: Select;
    private _rewardAvatarLevelSelect: Select;
    private _CollectionId: number;
    private _iconInput: ImageTextField;

    constructor(props: any) {
        super(props);
    }

    _initFields(settings: object) {
        this._CollectionId = null
        this._Pack = {} as Pack;
        super._initFields(settings);
        this._Mode = 'FullHeight';
        this._Caption = 'Pack Editor';
        this._CloseOnFrameMouseDown = true;
        this._ShowHeader = true;
        this._ShowCloseButton = true;
        this._OkRK = 'Save';
        this._AutoDestroy = true;
    }

    _render() {
        super._render();


        this._name_en = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Name (en)'
        });
        this._name_ru = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Name (ru)'
        });
        this._name_es = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Name (es)'
        });
        this._name_pt = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Name (pt)'
        });

        this._backgroundColorInput = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Background color'
        });

        this.completion_giftInput = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Completion gift'
        });

        this._rewardFighterCtrl = new SelectFighterCtrl({
            ParentNode: this._contentNode,
            FloatingLabel: 'Reward Athlete Card',
            SportType: SportType.MMA
        });

        this._rewardCoinsInput = new NumField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Reward Coins'
        });

        this._rewardDiamondsInput = new NumField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Reward Diamonds'
        });

        this._rewardCardPackageStatusSelect = new Select({
            ParentNode: this._contentNode,
            FloatingLabel: 'Reward Card Package Status',
            Items: [
                {Content: '— None —', Value: null},
                {Content: 'Bronze', Value: 'bronze'},
                {Content: 'Silver', Value: 'silver'},
                {Content: 'Gold', Value: 'gold'}
            ]
        });

        this._rewardAvatarCategorySelect = new Select({
            ParentNode: this._contentNode,
            FloatingLabel: 'Reward Avatar Category',
            Items: [
                {Content: '— None —', Value: null},
                {Content: 'Boxers', Value: 'Boxers'},
                {Content: 'Ankle Support', Value: 'AnkleSupport'},
                {Content: 'Gloves', Value: 'Gloves'},
                {Content: 'Training', Value: 'Training'},
                {Content: 'Equipment', Value: 'Equipment'},
                {Content: 'Sports Nutrition', Value: 'SportsNutrition'},
            ]
        });

        this._rewardAvatarLevelSelect = new Select({
            ParentNode: this._contentNode,
            FloatingLabel: 'Reward Avatar Level',
            Items: [
                {Content: '— None —', Value: null},
                {Content: 'Basic', Value: 'basic'},
                {Content: 'Pro', Value: 'pro'},
                {Content: 'Epic', Value: 'epic'},
            ]
        });

        this._iconInput = new ImageTextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Background image url'
        });

        this.refresh();
    }

    async refresh() {

        if (this._Pack.id) {
            this._name_en.setValue(this._Pack.name_en);
            this._name_ru.setValue(this._Pack.name_ru);
            this._name_es.setValue(this._Pack.name_es);
            this._name_pt.setValue(this._Pack.name_pt);
            this._backgroundColorInput.setValue(this._Pack.background_color);
            this.completion_giftInput.setValue(this._Pack.completion_gift);
            this._iconInput.setValue(this._Pack.backgroundImage);
            if (this._Pack.reward_athlete_card_id) {
                this._rewardFighterCtrl.setValue(this._Pack.reward_athlete_card_id);
            }
            if (this._Pack.reward_coins) {
                this._rewardCoinsInput.setValue(this._Pack.reward_coins);
            }
            if (this._Pack.reward_diamonds) {
                this._rewardDiamondsInput.setValue(this._Pack.reward_diamonds);
            }
            if (this._Pack.reward_card_package_status) {
                this._rewardCardPackageStatusSelect.setValue(this._Pack.reward_card_package_status);
            }
            if (this._Pack.reward_avatar_category_key) {
                this._rewardAvatarCategorySelect.setValue(this._Pack.reward_avatar_category_key);
            }
            if (this._Pack.reward_avatar_item_level) {
                this._rewardAvatarLevelSelect.setValue(this._Pack.reward_avatar_item_level);
            }
        } else {
            this._Pack.collection_id = this._CollectionId
        }
    }

    async _onOkButtonClick() {

        this._Pack.name_en = this._name_en.getValue();
        this._Pack.name_ru = this._name_ru.getValue();
        this._Pack.name_es = this._name_es.getValue();
        this._Pack.name_pt = this._name_pt.getValue();
        this._Pack.background_color = this._backgroundColorInput.getValue();
        this._Pack.completion_gift = this.completion_giftInput.getValue();
        if (this._CollectionId)
            this._Pack.collection_id = this._CollectionId;

        const selectedAthlete = this._rewardFighterCtrl.getSelectedAthlete();
        this._Pack.reward_athlete_card_id = selectedAthlete ? selectedAthlete.Id : null;
        this._Pack.reward_coins = this._rewardCoinsInput.getValue() ? Number(this._rewardCoinsInput.getValue()) : null;
        this._Pack.reward_diamonds = this._rewardDiamondsInput.getValue() ? Number(this._rewardDiamondsInput.getValue()) : null;
        this._Pack.reward_card_package_status = this._rewardCardPackageStatusSelect.getValue() || null;
        this._Pack.reward_avatar_category_key = this._rewardAvatarCategorySelect.getValue() || null;
        this._Pack.reward_avatar_item_level = this._rewardAvatarLevelSelect.getValue() || null;
        this._Pack.backgroundImage = this._iconInput.getValue();

        if (this._Pack.id) {
            await ServerAPI.put(`/fantasy/card-collections/packs/${this._Pack.id}`, this._Pack);
        } else {
            await ServerAPI.post(`/fantasy/card-collections/packs`, this._Pack);
        }

        this.EvOkButtonClick.fire(this);
        this.hide();
    }
}